import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import config from "../../config";
import ProductsDropDown from "../Shared/ProductsDropDown";
import AccountDropDown from "../Shared/AccountDropDown";
import moment from "moment";
import dayjs from "dayjs";
import {
  Table,
  Pagination,
  Button,
  DatePicker,
  Form,
  Select,
  Row,
  Col,
  Spin,
  Card,
} from "antd";
import { NavLink } from "react-router-dom";
import { PrinterOutlined } from "@ant-design/icons";
import LoginChecked from "../Shared/LoginChecked";
import BoxCard from "../Shared/BoxCard";
import { NozzleOil } from "../UserControls/Icons";
import { NumberFormat } from "../Shared/Utility";
function SalesReport() {
  const { RangePicker } = DatePicker;

  const [loading, setLoading] = useState(false);

  const [StartDate, SetStartDate] = useState(
    dayjs().subtract(60, "day").format("YYYY-MM-DD")
  );
  const [EndDate, SetEndDate] = useState(dayjs().format("YYYY-MM-DD"));
  const AccessKey = localStorage.getItem("AccessKey");
  const productTypesArray = ProductsDropDown();
  const UserID = localStorage.getItem("ID");
  const [salesReport, setSalesReport] = useState();
  const [ProductID, setProductID] = useState(0);
  const accounts = AccountDropDown();
  const [CustomerID, SetCustomerID] = useState(0);
  const [AccountID, SetAccountID] = useState(0);
  const [salesData, setSalesData] = useState([]);
  const [totalRecords, setTotalRecords] = useState("");

  // pagination
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(50);

  useEffect(() => {
    document.title = "Sales Report";

    setLoading(true);
    const data = {
      UserID: UserID,
      AccessKey: AccessKey,
      PageNo: pageNo,
      PageSize: pageSize,
      StartDate: StartDate,
      EndDate: EndDate,
      ProductID: ProductID,
      CustomerID: CustomerID,
      AccountID: 0,
    };

    var api_config = {
      method: "post",
      url: config.base_url + "Report/GetSalesReport",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
       
        if (response.data.status_code == 1) {
          setSalesReport(response.data.listofSales);
          setSalesData(response.data);
          SetAccountID(response.data.listofSales?.[0]?.Account_ID);
          setTotalRecords(response.data.totalRecords);
          setLoading(false);
        } else {
          // Handle error
          setLoading(false);
        }
        //   setLoading(false);
      })
      .catch(function (error) {});
  }, [StartDate, EndDate, CustomerID, ProductID, pageNo, pageSize]);

  const handleCustomerChange = (value) => {
    SetCustomerID(value);
  };

  const onPageChange = (page, pageSize) => {
    setPageNo(page);
  };

  const onPageSizeChange = (current, size) => {
    setPageNo(1);
    setPageSize(size);
  };

  const columns = [
    {
      title: "Serial No",
      dataIndex: "SerialNo",
      key: "SerialNo",
      render: (_, record, index) => index + 1 + pageSize * (pageNo - 1),
    },
    {
      title: "Dated",
      dataIndex: "",
      key: "Dated",
      render: (_, record) =>
        moment(record.Sale_Invoice_Head_BE?.Dated).format("DD MMM YYYY"),
    },
    {
      title: "Customer",
      dataIndex: "Customer",
      key: "Customer",
      render: (_, record) => record.Account_BE?.Name,
    },
    {
      title: "Product",
      dataIndex: "Product",
      key: "Product",
      render: (_, record) => record.Product_BE?.Name,
    },
    {
      title: "Receipt",
      dataIndex: "Receipt_No",
      key: "Receipt",
    },
    {
      title: "Vehicle",
      dataIndex: "Vehicle_No",
      key: "Vehicle",
    },
    {
      title: "Price",
      dataIndex: "Price",
      key: "Price",
      align: "right",
      render: (_, record) => NumberFormat(record.Price),
    },
    {
      title: "	Quantity",
      dataIndex: "Quantity",
      key: "	Quantity",
      render: (_, record) => NumberFormat(record.Quantity),
    },
    {
      title: "Amount",
      dataIndex: "Amount",
      key: "Amount",
      align: "right",
      render: (_, record) => NumberFormat(record.Amount, 0),
    },
  ];
  const handleDateChange = (date, value) => {
    SetStartDate(value[0]);
    SetEndDate(value[1]);
  };

  const disableDate = (current) => {
    return current && current > moment().endOf("day");
  };

  const handleProductChange = (value) => {
    setProductID(value);
  };
  return (
    <>
      <LoginChecked />
      <div className="right-side-contents">
        <div className="page-content">
          <div className="page-header">
            <h3 className="page-title">Sales Report</h3>

            <div className="header-actions">
              <NavLink
                to={`/report-sale/print-list/?StartDate=${StartDate}&EndDate=${EndDate}&ProductID=${ProductID}&AccountID=${AccountID}`}
                target="_blank"
              >
                <Button
                  type="dashed"
                  size="large"
                  shape="round"
                  // style={{ marginBottom: 10 }}
                >
                  <PrinterOutlined />
                  Print Report
                </Button>
              </NavLink>
            </div>
          </div>
          <div className="table-detail-header">
            <Row gutter={[20, 10]}>
              <Col md={6} xs={24}>
                <BoxCard
                  loading={loading}
                  title="Total Sale"
                  prefix="Rs."
                  amount={salesData.TotalSales}
                  icon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      stroke="#6FB2FF"
                      class="size-6"
                      viewBox="0 0 30 30"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M2.25 18.75a60.07 60.07 0 0 1 15.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 0 1 3 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 0 0-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 0 1-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 0 0 3 15h-.75M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm3 0h.008v.008H18V10.5Zm-12 0h.008v.008H6V10.5Z"
                      />
                    </svg>
                  }
                />
              </Col>
              <Col md={6} xs={24}>
                <BoxCard
                  loading={loading}
                  title="Cash Sale"
                  amount={salesData.TotalCashSales}
                  prefix="Rs."
                  icon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      stroke="#6FB2FF"
                      class="size-6"
                      viewBox="0 0 30 30"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="m9 12.75 3 3m0 0 3-3m-3 3v-7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                      />
                    </svg>
                  }
                />
              </Col>
              <Col md={6} xs={24}>
                <BoxCard
                  loading={loading}
                  title="Credit Sales"
                  amount={salesData.TotalCreditSales}
                  prefix="Rs."
                  icon={
                    <svg
                      viewBox="0 0 30 30"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      stroke="#6FB2FF"
                      class="size-6"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="m15 11.25-3-3m0 0-3 3m3-3v7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                      />
                    </svg>
                  }
                />
              </Col>

              <Col md={6} xs={24}>
                <BoxCard
                  title="Diesel"
                  loading={loading}
                  amount={salesData.TotalDieselQty}
                  suffix="Ltr"
                  icon={
                    <svg
                      viewBox="0 0 60 60"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M41.0969 36.1109C41.0922 36.1133 41.0946 27.8054 41.0946 27.8054C41.7641 27.0183 42.1442 26.0259 42.1719 24.9929C42.1516 23.9557 41.7707 22.9579 41.0946 22.1711V13.8672C45.3797 7.70701 35.8711 3.32029 25.8133 3.13279C25.7107 3.13069 25.6087 3.14882 25.5131 3.18613C25.4175 3.22345 25.3302 3.27923 25.2562 3.35029C25.1822 3.42135 25.1229 3.50629 25.0817 3.60028C25.0405 3.69426 25.0182 3.79543 25.0161 3.89803C25.014 4.00062 25.0321 4.10263 25.0694 4.19822C25.1067 4.29381 25.1625 4.38111 25.2336 4.45515C25.3046 4.52918 25.3896 4.58849 25.4835 4.6297C25.5775 4.6709 25.6787 4.69319 25.7813 4.69529C34.1633 4.87029 43.4563 8.38826 39.7258 13.0937C37.054 16.1375 29.393 18.0015 21.4899 17.2547C5.65161 15.6281 4.88052 6.26873 22.7188 4.76404C22.9231 4.74815 23.113 4.65259 23.2476 4.49797C23.3821 4.34335 23.4505 4.14206 23.438 3.93748C23.4255 3.73291 23.3331 3.54144 23.1807 3.40436C23.0284 3.26728 22.8282 3.19556 22.6235 3.20467C14.0508 3.72654 7.82817 7.02811 7.82817 11.0547C7.85533 12.0873 8.23557 13.0794 8.90552 13.8656V22.1726C8.21453 22.9482 7.83272 23.9507 7.83272 24.9894C7.83272 26.0282 8.21453 27.0307 8.90552 27.8062V36.1094C8.22858 36.901 7.84751 37.9031 7.82739 38.9445C7.82739 43.3906 15.3704 46.875 25 46.875C35.3868 46.8656 45.4524 42.5195 41.0969 36.1109ZM25 45.3125C15.4586 45.2234 8.14849 41.9453 9.64224 37.8726C12.493 40.5062 18.3829 42.1773 25 42.1773C25.2072 42.1773 25.406 42.095 25.5525 41.9485C25.699 41.802 25.7813 41.6033 25.7813 41.3961C25.7813 41.1889 25.699 40.9902 25.5525 40.8436C25.406 40.6971 25.2072 40.6148 25 40.6148C18.661 40.6148 12.9141 38.9765 10.468 36.4836V29.2898C11.0006 29.6738 11.5625 30.0155 12.1485 30.3117C17.6188 33.1273 26.1079 33.543 32.3907 32.1781C32.491 32.1566 32.5861 32.1155 32.6706 32.0572C32.755 31.9989 32.8272 31.9245 32.8829 31.8383C32.9386 31.7521 32.9768 31.6558 32.9953 31.5549C33.0138 31.4539 33.0122 31.3503 32.9907 31.25C32.9691 31.1496 32.928 31.0545 32.8697 30.9701C32.8114 30.8856 32.7371 30.8135 32.6509 30.7578C32.5647 30.702 32.4684 30.6639 32.3674 30.6454C32.2665 30.6269 32.1629 30.6284 32.0625 30.65C30.8984 30.901 29.7206 31.0844 28.5352 31.1992C22.4383 31.6726 14.5618 31.1765 10.2704 27.0273C9.8531 26.6417 9.56808 26.1343 9.45587 25.5773C9.34366 25.0203 9.40997 24.4421 9.64536 23.925C12.3383 26.6672 19.6946 28.3805 25 28.2375C25.2072 28.2375 25.406 28.1552 25.5525 28.0087C25.699 27.8621 25.7813 27.6634 25.7813 27.4562C25.7813 27.249 25.699 27.0503 25.5525 26.9038C25.406 26.7573 25.2072 26.675 25 26.675C23.7888 26.6758 22.5782 26.6169 21.3727 26.4984C16.4899 26.0094 12.3633 24.5047 10.468 22.5429V15.35C17.2883 20.2015 32.7 20.2125 39.5321 15.3445V22.5125C39.4805 23.032 39.6313 23.5219 40.2 23.614C41.8813 26.7594 37.7086 28.8461 35.0915 29.7937C34.9197 29.857 34.7756 29.9784 34.684 30.1369C34.5924 30.2954 34.5592 30.4809 34.5901 30.6613C34.621 30.8417 34.7141 31.0055 34.8532 31.1245C34.9923 31.2434 35.1686 31.3099 35.3516 31.3125C36.8516 30.8852 38.2661 30.2008 39.5321 29.2898V36.8031C39.5335 36.9895 39.6023 37.169 39.7258 37.3086C39.8493 37.4482 40.0192 37.5383 40.204 37.5625C40.4613 37.9779 40.6017 38.4551 40.6102 38.9437C40.6102 42.0195 34.3375 45.3125 25 45.3125Z"
                        fill="#6FB2FF"
                      />
                      <path
                        d="M30.2094 11.6703C31.3688 14.8656 38.5742 14.4906 38.6492 10.889C38.5711 7.28746 31.3703 6.91246 30.2094 10.1078H29.5094C29.3022 10.1078 29.1035 10.1901 28.957 10.3366C28.8105 10.4831 28.7281 10.6818 28.7281 10.889C28.7281 11.0962 28.8105 11.2949 28.957 11.4414C29.1035 11.588 29.3022 11.6703 29.5094 11.6703H30.2094ZM34.3485 9.47105C37.9578 9.60386 37.9578 12.1757 34.3485 12.307C30.7391 12.1757 30.7391 9.60386 34.3485 9.47105Z"
                        fill="#6FB2FF"
                      />
                    </svg>
                  }
                />
              </Col>
              <Col md={6} xs={24}>
                <BoxCard
                  loading={loading}
                  title="Petrol"
                  suffix="Ltr"
                  amount={salesData.TotalPetrol}
                  icon={<NozzleOil />}
                />
              </Col>
            </Row>
          </div>

          <div className="filters-wrap ">
            <Form>
              <Form.Item>
                <RangePicker
                  allowClear
                  onChange={handleDateChange}
                  disabledDate={disableDate}
                />
              </Form.Item>
              <Form.Item>
                <Select
                  allowClear
                  showSearch
                  style={{
                    width: "160px",
                  }}
                  placeholder="All Customers"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                  loading={accounts ? false : true}
                  options={accounts}
                  onChange={handleCustomerChange}
                />
              </Form.Item>
              <Form.Item>
                <Select
                  allowClear
                  showSearch
                  style={{
                    width: "160px",
                  }}
                  placeholder="All Products"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                  loading={productTypesArray ? false : true}
                  options={productTypesArray}
                  onChange={handleProductChange}
                />
              </Form.Item>
            </Form>
          </div>

          <Table
            size="small"
            scroll={{
              x: "100%",
            }}
            loading={loading}
            columns={columns}
            dataSource={salesReport}
            // onChange={handleTableChange}
            pagination={false}
            bordered
          />
          <div className="text-end mt-5">
            <Pagination
              current={pageNo}
              pageSize={pageSize}
              size="small"
              total={totalRecords}
              onChange={onPageChange}
              onShowSizeChange={onPageSizeChange} // Handle page size change
              showSizeChanger
              showQuickJumper
              showTotal={(total) => `Total ${total} items`}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default SalesReport;
